import { useEffect, useState, useRef, useCallback } from "react";

interface IUseHeaderScrollProps {
  wrapperRef: React.RefObject<HTMLElement>;
}

export const useHeaderScroll = ({ wrapperRef }: IUseHeaderScrollProps) => {
  const [isFixed, setIsFixed] = useState(false);
  const prevScrollY = useRef(0);

  const handleScroll = useCallback(() => {
    if (!wrapperRef.current) {
      return;
    }

    const currentScrollY = wrapperRef.current.scrollTop;
    const prevScroll = prevScrollY.current < 0 ? 0 : prevScrollY.current;
    const isScrolledDown = currentScrollY > prevScroll;

    setIsFixed(isScrolledDown);
    prevScrollY.current = currentScrollY;
  }, [wrapperRef]);

  useEffect(() => {
    const currentWrapper = wrapperRef.current;
    if (!currentWrapper) {
      return;
    }

    currentWrapper.addEventListener("scroll", handleScroll);
    return () => {
      currentWrapper.removeEventListener("scroll", handleScroll);
    };
  }, [wrapperRef, handleScroll]);

  return { isFixed };
};
